<div class="row" style="min-height: 128px; height: 100%">
  <div class="col-7 content-status d-flex flex-column justify-content-between">
    <div class="row content-fee" style="margin-left: 5px">
      <div class="col-5 mt-3">
        <div class="form-group mb-0 row justify-content-center adjust-fee-percentage align-items-center">
          <label class="d-flex col-form-label font-poppins font-verde text-fee mr-1">Fee</label>
          <div class="d-flex content-input-fee mr-1">
            <input
              type="text"
              class="form-control font-poppins font-weight-bold f-16 input-fee"
              (change)="updateItemsFee($event)"
              [ngModel]="item.item.status_id === 1 && item.item.source === 'Web' ? percentage : item.item.percentageAgent"
              min="0"
              max="99"
              oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 99) this.value = 99;"
              [disabled]="
                userService.activeGlobalFee ||
                item.item.status_id === 2 ||
                item.item.status_id === 5 ||
                item.item.isPendigApprovePay === true ||
                item.item.isPaidAgency === true ||
                item.item.isPaidProvider === true ||
                item.item.isBilled === true ||
                item.item.source !== 'Web' ||
                (item.item.status_id === 1 && item?.item?.syncProduct && item?.item?.syncProduct?.alert) ||
                modifications
              "
            />
          </div>
          <label class="d-flex col-form-label font-poppins font-verde text-fee">%</label>
          <div class="d-flex" style="margin-left: 5px">
            <a style="cursor: pointer; position: absolute; top: 2px; left: 47px !important; z-index: 1" title="NR">
              <span class="icon-nr font-poppins" *ngIf="item.item.nr">NR</span>
            </a>
            <div></div>
          </div>
        </div>
      </div>
      <div
        class="col-7 d-flex justify-content-center align-items-center mt-3"
        *ngIf="status !== 'price-non-available' && status !== 'room-non-available' && status !== 'non-available'"
      >
        <span *ngIf="item.item.status_id === 1" class="status-fee product-status-saved">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 2" class="status-fee product-status-reserved">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 3" class="status-fee product-status-locked">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 4" class="status-fee product-status-denied">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 5" class="status-fee product-status-cancelled">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 6" class="status-fee product-status-paid-agency">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 7" class="status-fee product-status-paid-provider">{{ item.item.status }}</span>
        <span *ngIf="item.item.status_id === 8" class="status-fee product-status-completed">{{ item.item.status }}</span>
      </div>
    </div>

    <div class="conditions" *ngIf="item.item.status_id != 5">
      <!-- CASO 1  NO HAY CAMBIOS-->

        <div *ngIf="!item.item?.syncProduct?.alert && showTextChangeDetailsProducts && item.item.status_id === 1"
              class="row align-items-center justify-content-end mr-3">
          <div class="d-flex flex-column align-items-end" *ngIf="item.item?.syncProduct?.dateTimeVerifed">
            <img src="../../../../assets/icons/itinerary-detail/CHECK.svg" class="mb-2" style="width: 20px;" alt="">
            <p class=" date-verifed nt-poppins font-medium m-0" style="line-height: 1">Última Verificación</p>
            <p class=" date-verifed nt-poppins font-medium m-0"  style="line-height: 1">
              {{ item.item?.syncProduct?.dateTimeVerifed | date : "dd/MM/yyyy" }}
            </p>
          </div>

          <span class="date-verifed nt-poppins pt-1 font-medium m-0 f-10" *ngIf="item.item?.syncProduct?.message">
            <div class="d-flex align-items-center px-0 position-icon-check">
              <span class="ml-2 mt-1 date-verifed nt-poppins font-medium m-0" style="text-align: end;">{{ item.item?.syncProduct?.message }} </span>
            </div>
          </span>
        </div>

      <!-- OCURRIO UN CAMBIO -->
      <div class="mb-2 mt-1 ml-1 mr-3"  *ngIf="item.item?.syncProduct?.alert && showTextChangeDetailsProducts && item.item.status_id === 1">

        <!-- CASO 2  CAMBIO DE PRECIOS -->
        <div class="row flex-column mt-2 ml-4 mr-1" *ngIf="item.item?.syncProduct?.priceNonAvailable && showTextChangeDetailsProducts">
          <div class="d-flex flex-column align-items-end" *ngIf="item.item?.syncProduct?.dateTimeVerifed">
            <img
            src="../../../../assets/icons/itinerary-detail/ALERTA-01.svg"
            class="mb-2"
            style="width: 20px;"
            [style.filter]="getAlertFilter(item)"
            alt="">
            <p class=" date-verifed nt-poppins font-regular m-0" style="line-height: 1; color: #00d397;font-size: 13px;text-align: end;width: 125px;">{{ item.item?.syncProduct?.message }}</p>
          </div>
          <div class="d-flex flex-column px-0 align-items-end mt-2 " >
            <p class=" mb-0 py-2 px-3" style="color: black; font-size: 11px; font-weight: 400;border-radius: 50rem;background-color: #00d397;line-height: 1"
            >{{item.item?.syncProduct?.newPrice?.percentageChange}} %</p>
          </div>
        </div>

        <!-- CASO 3  PRODUCTO NO DISPONIBLE -->
        <div class="row mx-auto flex-column mt-2 pl-4" *ngIf="item.item?.syncProduct?.nonAvailable && item.item.status_id === 1">
          <div class="d-flex flex-column align-items-end" *ngIf="item.item?.syncProduct?.dateTimeVerifed">
            <img src="../../../../assets/icons/itinerary-detail/ALERTA-01.svg"
             class="mb-2"
             style="width: 20px;"
              [style.filter]="getAlertFilter(item)"
             alt="">
            <p class=" date-verifed nt-poppins font-regular m-0" style="line-height: 1; color: #d60159;width: 125px;text-align: end">{{ item.item?.syncProduct?.message }}</p>
          </div>

        </div>


         <!-- CASO 5 ERROR OCTOPUS -->
        <div class="row mx-auto flex-column mt-2 pl-4" *ngIf="showTextChangeDetailsProducts &&
                                                              !item.item?.syncProduct?.nonAvailable &&
                                                              !item.item?.syncProduct?.priceNonAvailable &&
                                                              item.item?.syncProduct?.codeLabelStatus !== 'PRODUCT_CANCELLATION_POLICY_CHANGED' &&
                                                              item.item.status_id === 1">
        <div class="d-flex flex-column align-items-end" *ngIf="item.item?.syncProduct?.dateTimeVerifed">
          <img src="../../../../assets/icons/itinerary-detail/ALERTA-01.svg"
             class="mb-2"
             style="width: 20px;"
              [style.filter]="getAlertFilter(item)"
             alt="">
            <p class=" date-verifed nt-poppins font-regular m-0" style="line-height: 1; color: #d60159;width: 200px;text-align: end">{{ item.item?.syncProduct?.message }}</p>
          </div>

        </div>
      </div>
      <!-- POLITICAS DE CANCELACIÓN -->

      <!-- CASO 4  POLÍTICAS DE CANCELACIÓN -->
        <div (mouseenter)="showTooltip = true"  (mouseleave)="showTooltip = false" class="mb-2 mt-1 ml-1 mr-3" style=" cursor: pointer" *ngIf="item.item?.syncProduct?.codeLabelStatus === 'PRODUCT_CANCELLATION_POLICY_CHANGED' && showTextChangeDetailsProducts">
            <div class="d-flex flex-column align-items-end" *ngIf="item.item?.syncProduct?.dateTimeVerifed">
            <img src="../../../../assets/icons/itinerary-detail/ALERTA-01.svg" class="mb-2" style="width: 20px;" alt="">
            <p class=" date-verifed nt-poppins font-medium m-0 " style="line-height: 1;width: 200px;text-align: end">{{ item.item?.syncProduct?.message }}</p>
            </div>

            <div class="d-flex flex-column px-0" style="position: relative">
                <div class="d-flex justify-content-end">
                <span
                      class=" date-verifed nt-poppins font-medium m-0"

                      style="color: #00d397;">
                  Ver nuevas políticas
                </span>
              </div>
                <div class="tooltip-info2  shadow-md" *ngIf="showTooltip">
                  <table>
                    <tr>
                      <th style="text-align: center">
                        <p>Políticas anteriores</p>
                      </th>
                      <th style="text-align: center">
                        <p>Políticas actualizadas</p>
                      </th>
                    </tr>
                      <tr>
                        <ng-container *ngFor="let cancellation of getCancellationPoliciesBefore(item, 'before')?.before">
                           <td style="text-align: start">
                          <p class="mb-2" style="color: black">
                            {{ (cancellation.from || cancellation.dateFrom) | date: 'dd/MM/yyyy' }} -
                            {{currencyAgency?.code}} {{ cancellation.amount | currencyConverterPure: cancellation.currency: currencyAgency.code: currencies | number: '1.2-2'}}
                          </p>
                        </td>
                        </ng-container>
                        <ng-container *ngFor="let cancellation of getCancellationPoliciesBefore(item, 'after')?.after">
                          <td>
                            <p class="mb-2" style="color: black">
                              {{ (cancellation.from || cancellation.dateFrom) | date: 'dd/MM/yyyy' }} -
                              {{currencyAgency?.code}} {{ cancellation.amount | currencyConverterPure: cancellation.currency: currencyAgency.code: currencies | number: '1.2-2'}}
                            </p>
                          </td>
                        </ng-container>
                      </tr>
                  </table>
                </div>
              </div>
        </div>


        <div  *ngIf="item.item.status_id === 2 && item?.item?.expiration_date && !item?.item?.isPendigApprovePay && !item?.item?.isPaidAgency && !item.item?.isPaidProvider"
              class="row align-items-center justify-content-end mr-3 mb-3">
          <div class="d-flex flex-column align-items-end">
            <div class="d-flex" style="gap:4px">
              <p class=" date-verifed nt-poppins font-medium" 
                 style="line-height: 1; margin-bottom:4px;"
                
                 >Vencimiento</p>
              <img src="../../../assets/icons/admi_01.svg" 
                  width="12px" 
                  tooltip="Fecha de vencimiento del producto. Una vez transcurrida esta fecha, si el producto no ha sido pagado, el sistema cancelará automáticamente la reserva sin necesidad de acción adicional."
                  placement="bottom"
                  style="margin-top: -4px;cursor: pointer"
                  alt="">
            </div>
       
            <p *ngIf="item?.item?.expiration_date" class=" date-verifed nt-poppins font-medium m-0"  style="line-height: 1; color: #d60159;">
              {{ item?.item?.expiration_date | date : "dd/MM/yyyy" }}
            </p>

              <p *ngIf="!item?.item?.expiration_date" class=" date-verifed nt-poppins font-medium m-0"  style="line-height: 1; color: #d60159;">
                No disponible
            </p>
          </div>
        </div>

    </div>

        <div class="conditions" >
        <div class="row align-items-center justify-content-end mr-3 mb-3">
          <div class="d-flex flex-column align-items-end" *ngIf="item.item.status_id == 5">
             <div class="d-flex" style="gap:4px">
              <p class=" date-verifed nt-poppins font-medium" style="line-height: 1; margin-bottom:4px;">Fecha cancelación</p>
                <img src="../../../assets/icons/admi_01.svg" 
                  width="12px" 
                  tooltip="Fecha de cancelación de la reserva registrada. La cancelación fue ejecutada por el usuario previo a la fecha de inicio del servicio."
                  placement="bottom"
                  style="margin-top: -4px;cursor: pointer"
                  alt="">
             </div>
            
            <p class=" date-verifed nt-poppins font-medium m-0"  style="margin-top: 6px;line-height: 1;color: #d60159;">

              {{ item?.item?.updated_at | date : "dd/MM/yyyy" }}
            </p>
          </div>

          <div class="d-flex flex-column align-items-end mt-1" *ngIf="getPenality(item)">
             <div class="d-flex" style="gap:4px">
              <p class=" date-verifed nt-poppins font-medium" style="line-height: 1;margin-bottom:4px;">Penalidad por cancelación</p>
               <img src="../../../assets/icons/admi_01.svg" 
                  width="12px" 
                  tooltip="Monto correspondiente a la penalidad por cancelación, calculado conforme a las políticas de cancelación aplicables al producto reservado."
                  placement="bottom"
                  style="margin-top: -4px;cursor: pointer"
                  alt="">
             </div>
            
            <p class=" date-verifed nt-poppins font-medium m-0" style="line-height: 1;color: #d60159;">
              <ng-container *ngIf="item?.item?.amount_convert_cancellation">
                <ng-container *ngIf="hasPenality(item.item.amount_convert_cancellation)">
                  <ng-container *ngFor="let cancellation of item.item.amount_convert_cancellation">
                    <ng-container *ngIf="cancellation.apply">
                      {{ cancellation.currency }} {{ cancellation.amount | number: '1.2-2' }}
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!hasPenality(item.item.amount_convert_cancellation)">
                      {{ currencyAgency?.code }} {{ 0 | number: '1.2-2' }}
                </ng-container>
              </ng-container>
               <ng-container *ngIf="!item?.item?.amount_convert_cancellation">
                  <ng-container *ngFor="let cancellation of getCancellationPolicies(item.item.category_id, item.item)">
                    <ng-container *ngIf="cancellation.apply === true">
                      {{currencyAgency?.c}} {{cancellation.amount | currencyConverterPure:
                                                                      item.item.currency:
                                                                      currencyAgency.code:
                                                                      currencies
                                                                    | number: '1.2-2'}}
                    </ng-container>
                    <ng-container *ngIf="cancellation.apply === false">
                        {{ currencyAgency?.code }} {{ 0 | number: '1.2-2' }}
                    </ng-container>
                </ng-container>
              </ng-container>
            </p>
          </div>

        </div>



    </div>

    <div style="margin-left: 26px"  *ngIf="
          item.item.status_id == 1 && status !== 'price-non-available' && status !== 'room-non-available' && status !== 'non-available'
        ">
      <div
        class="d-flex"

      >
        <ng-container *ngIf="!(item.item?.syncProduct?.alert && showTextChangeDetailsProducts) && item.item.source === 'Web'">
          <div
            class="d-flex align-items-center mb-3"
            *ngIf="partialReserve === true"
            (change)="toPartialReserve($event, item)"
            ng-checked="item.status_id==3"
            style="width: 60px"
          >
            <span class="d-flex">
              <label class="custom-radio-checkbox m-0">
                <input class="custom-radio-checkbox__input" type="checkbox" name="partial_reserve" />
                <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
              </label>
            </span>
            <p class="font-poppins f-12 text-parcial-reserve m-0">Reserva ParciaL</p>
          </div>
        </ng-container>
      </div>
    </div>
       <div *ngIf="
          ((item.item.status_id === 2 && item.item.isPendigApprovePay === true) ||
            item.item.isPaidAgency === true ||
            item.item.isPaidProvider === true ||
            item.item.isBilled === true) &&
          status !== 'price-non-available' &&
          status !== 'room-non-available' &&
          status !== 'non-available'
        "
        class="d-flex justify-content-end w-100 px-3 mb-3"
      >
        <div class="d-flex align-items-center justify-content-center indicadores" >
          <span class="ind-pap mr-1 px-2" style="border-radius: 50rem;" *ngIf="item.item.isPendigApprovePay === true">PAP</span>
          <span class="ind-pa mr-1 px-2" style="border-radius: 50rem;" *ngIf="item.item.isPaidAgency === true">PA</span>
          <span class="mr-1 px-2" style="border-radius: 50rem;  background-color: #f9f9f9;" [ngClass]="{ 'ind-pp': item.item.isPaidProvider === true }">PP</span>
          <span style="border-radius: 50rem;width: 18px;text-align: center; background-color: #f9f9f9;" [ngClass]="{ 'ind-b': item.item.isBilled === true }">F</span>
        </div>
      </div>

  </div>


  <!-- PRECIOS -->
  <div class="col-5 card-price d-flex pl-0"
        [ngStyle]="{'border-left': item.item?.syncProduct?.nonAvailable ?
                                   '2px solid #d60159'  :
                                   '2px solid #00d397' }">
    <div class="row mx-auto flex-column adjust-card-price my-4 pr-1" style="width: 100%;">
      <div class="d-flex flex-column px-0" style="text-align: end">
        <p class="font-poppins f-15 font-weight-bold text-price text-uppercase mb-2 text-price-net-rate text-start">Tarifa Neta</p>
        <div class="d-flex justify-content-end">
          <p
            class="font-poppins text-start mb-0"
            style="line-height: 1; color: #858585; font-weight: 500;"
            [ngStyle]="{
              'font-size': (taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking )
                                      | currencyConverterPure:
                                        currencyItinerary:
                                        currencyAgency.code:
                                        currencies
                                      | dynamicFontSize: 15 : fontSizeAdjustments
            }"
          >
             <span *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider">
                              <span *ngIf="item.item.status_id !== 5">
                         {{currencyAgency.code}} {{ (taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking )
                                      | currencyConverterPure:
                                        currencyItinerary:
                                        currencyAgency.code:
                                        currencies
                                      | number: '1.2-2'}}
                            </span>
                            <span *ngIf="item.item.status_id === 5">
                              {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
                            </span>

             </span>

             <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts">
              <span *ngIf="item.item.status_id !== 5">
                {{currencyAgency.code}} {{ (item.item?.converted_amounts?.taxPrice > 0 ? item.item?.converted_amounts?.netPriceBookingFreeTax : item.item?.converted_amounts?.netPriceBooking ) | number: '1.2-2'}}
              </span>
              <span *ngIf="item.item.status_id === 5">
                 {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
              </span>
             </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts">
                <span *ngIf="item.item.status_id !== 5">
                        {{item.item.currency}} {{ (taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking ) | number : '1.2-2' }}
                </span>
              <span *ngIf="item.item.status_id === 5">
                 {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
              </span>
              </span>
          </p>
          <ng-container *ngIf="item.item.status_id !== 5">
              <span *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider">
                <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="item.item.currency"
                                                [valueProduct]="(taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking)"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts">
                  <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="currencyAgency.code"
                                                [valueProduct]="(item.item?.converted_amounts?.taxPrice > 0 ? item.item?.converted_amounts?.netPriceBookingFreeTax : item.item?.converted_amounts?.netPriceBooking )"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts">

              </span>
          </ng-container>
        </div>
         <div *ngIf="item.item.status_id !== 5 && item.item.currency !== currencyAgency?.code">
                                  <div class="d-flex justify-content-end align-items-center">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 15px; font-weight: 500;color: #858585; line-height: 1;"
                                    >{{item.item.currency}} {{ (taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking ) | number:'1.2-2'}}</p>
                                    <div class="info-tool d-flex flex-column position-relative">
                                        <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
      </div>

      <div class="d-flex flex-column px-0 position-relative mt-3" style="text-align: end"  *ngIf="taxes && taxes.length > 0 || taxSum > 0">

          <!-- COMENTADO YOVANNY 09-07-2024  <span *ngIf="taxSum > 0"> -->
          <div *ngIf="item.item.status_id !== 5" class="d-flex justify-content-end align-items-center">
            <div class="info-tool d-flex flex-column mr-1 position-relative" *ngIf="taxes && taxes.length > 0">
              <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">

              <!-- MODAL DE CARGOS -->
              <div class="tooltip-info p-4 d-flex flex-column align-items-start shadow-md">
                <h3
                  class="mb-3"
                  style="
                    font-size: 14px;
                    font-family: 'Lato';
                    font-weight: 700;
                    line-height: 1.2;
                    color: #000000;
                  "
                >
                  Descripción
                </h3>

                <div class="row w-100 m-0">
                  <!-- Impuestos incluidos y no incluidos -->
                  <div class="col-4 pl-0" style="border-right: 1px solid #ababab;">
                    <div class="d-flex flex-column" style="gap: 15px;">
                      <div *ngIf="taxesIncluded.length > 0" class="d-flex flex-column align-items-start">
                        <h4 class="mb-2" style="font-size: 13px; font-weight: 700; font-family: 'Lato'; line-height: 1.2; color: #000000;">Incluido en el precio</h4>

                        <ul class="m-0 p-0 d-flex flex-column" style="list-style: none;">
                          <ng-container *ngFor="let tax of taxesIncluded">
                            <li style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;">{{tax.description}}</li>
                          </ng-container>
                          <li *ngIf="taxesIncluded.length === 0" style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;"> - </li>
                        </ul>
                      </div>

                      <div *ngIf="taxesExcluded.length > 0"  class="d-flex flex-column align-items-start">
                        <h4 class="m-0" style="font-size: 13px; font-weight: 700; font-family: 'Lato'; line-height: 1.2; color: #000000;">No Incluido en el precio</h4>
                        <ul class="m-0 p-0 d-flex flex-column" style="list-style: none;">
                          <ng-container *ngFor="let tax of taxesExcluded">
                            <li style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;">{{tax.description}}</li>
                          </ng-container>
                          <li *ngIf="taxesExcluded.length === 0" style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;"> - </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Pagar en destino -->
                  <div class="col-4" style="border-right: 1px solid #ababab;">
                    <div class="d-flex flex-column h-100" style="gap: 15px;">
                      <div *ngIf="taxesIncluded.length > 0" class="d-flex flex-column">
                        <h4 class="mb-2" style="font-size: 13px; font-weight: 700; font-family: 'Lato'; line-height: 1.2; color: #000000;">Pagar en destino</h4>
                        <ul class="m-0 p-0 d-flex flex-column" style="list-style: none;">
                          <ng-container *ngFor="let tax of taxesIncluded">
                            <li style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;"> - </li>
                          </ng-container>
                          <li *ngIf="taxesIncluded.length === 0" style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;"> - </li>
                        </ul>
                      </div>

                      <div *ngIf="taxesExcluded.length > 0" class="d-flex flex-column align-items-start">
                        <h4 class="m-0" style="font-size: 13px; font-weight: 700; font-family: 'Lato'; line-height: 1.2; color: #000000; opacity: 0;">No Incluido en el precio</h4>

                        <ul class="m-0 p-0 d-flex flex-column" style="list-style: none;">
                          <ng-container *ngFor="let tax of taxesExcluded">
                            <li style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;">
                              {{ tax.currency }} {{ tax.amount | number:'1.2-2' }}
                            </li>
                          </ng-container>
                          <li *ngIf="taxesExcluded.length === 0" style="font-size: 13px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;"> - </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Tarifa neta -->
                  <div class="col-4 pr-0">
                    <div class="d-flex flex-column">
                      <h4 class="m-0" style="font-weight: 700; font-size: 13px; line-height: 1.2; color: #000000; font-family: 'Lato';">TARIFA NETA</h4>
                      <div class="d-flex align-items-center" style="color: #000000; font-size: 13px; font-weight: 700; line-height: 1.2; font-family: 'Lato';">
                        {{ currencyAgency?.code }}
                        {{ (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax ) | currencyConverterPure: item.item.currency: currencyAgency?.code: currencies | number: '1.2-2'}}

                        <div style="width: 8px; height: 8px;">
                          <usb-tooltip-convert-amount
                            [clientsSettingAppBooking]="clientsSettingAppBooking"
                            [currencyProduct]="item.item.currency"
                            [valueProduct]="(netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax )"
                          ></usb-tooltip-convert-amount>
                        </div>
                      </div>
                      <div class="d-flex align-items-center" style="color: #000000; font-size: 12px; font-weight: 500; line-height: 1.2; font-family: 'Lato';">
                        {{item.item.currency}} {{(netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax ) | number:'1.2-2'}}
                      </div>
                    </div>
                  </div>
                </div>

                <hr style="border: none; border-bottom: 1px solid #ababab; width: 100%;" />

                <h4 class="m-0" style="font-size: 13px; font-weight: 600; font-family: 'Lato'; line-height: 1.2; color: #000000;">Valor por noche</h4>

                <!-- Valor por noche - Owl Carousel -->
                <div *ngIf="item.item.room.pricing.dailyPrices && item.item.room.pricing.dailyPrices.length > 0" class="mt-2 w-100">
                  <owl-carousel-o [options]="nightPriceOptions" class="night-price-carousel">

                    <ng-template
                      carouselSlide
                      [width]="90"
                      *ngFor="let price of item.item.room.pricing.dailyPrices">

                      <div
                        class="night-price-slide text-start"
                        style="min-width: 30px; padding: 5px;"
                      >

                        <p
                          class="mb-0"
                          style="font-size: 12px; font-weight: 600; font-family: 'Lato'; color: #000000; line-height: 1.2;">
                          {{ getDayName(price.date) }}
                        </p>

                        <p
                          class="mb-0"
                          style="font-size: 12px; font-weight: 500; font-family: 'Lato'; color: #000000; line-height: 1.2;">
                          {{ price.date }}
                        </p>

                        <div
                          class="mb-0 d-flex align-items-center"
                          style="font-size: 13px; font-weight: 700; font-family: 'Lato'; color: #000000; line-height: 1.2;">
                          {{ price.currency }} {{ price.price | number:'1.2-2' }}
                          <div style="width: 8px; height: 8px;">
                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientsSettingAppBooking"
                              [currencyProduct]="price.currency"
                              [valueProduct]="price.price"
                            ></usb-tooltip-convert-amount>
                          </div>
                        </div>

                      </div>

                    </ng-template>

                  </owl-carousel-o>
                </div>

                <!-- <table> -->
                <!--   <tr> -->
                <!--     <th style="text-align: start"> -->
                <!--       <p class="pl-4">Descripción</p> -->
                <!--     </th> -->
                <!--     <th> -->
                <!--       <p>Impuesto</p> -->
                <!--     </th> -->
                <!--   </tr> -->
                <!--   <ng-container *ngFor="let tax of taxes"> -->
                <!--     <tr> -->
                <!--       <td style="text-align: start"> -->
                <!--         <p class="mb-2" style="color: black">{{ tax.description }}</p> -->
                <!--       </td> -->
                <!--       <td> -->
                <!--         <!-- <p>{{currencyItinerary}} {{ tax.amount | number: '1.2-2' }}</p> --> -->
                <!--          <p style="color: black"> -->
                <!--             {{currencyAgency?.code}} {{ (tax.amount ) -->
                <!--                       | currencyConverterPure: -->
                <!--                         currencyItinerary: -->
                <!--                         currencyAgency?.code: -->
                <!--                         currencies -->
                <!--                       | number: '1.2-2'}} -->
                <!--          </p> -->
                <!--       </td> -->
                <!--     </tr> -->
                <!--   </ng-container> -->
                <!-- </table> -->
              </div>
            </div>

            <p class="font-poppins f-15 font-weight-bold text-price text-uppercase mb-2 text-price-net-rate text-start">Cargos</p>
          </div>
          <div class="d-flex justify-content-end">
            <p *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider"
              class="font-poppins text-start mb-0"
              style="line-height: 1;color: #858585; font-weight: 500;"
              [ngStyle]="{
                'font-size':  taxSum
                            | currencyConverterPure:
                              currencyItinerary:
                              currencyAgency?.code:
                              currencies
                            | dynamicFontSize: 15 : fontSizeAdjustments
              }"
            >
            <!-- {{currencyItinerary}} {{ taxSum | number : "1.2-2" }} -->
             {{currencyAgency?.code}} {{ taxSum
                                      | currencyConverterPure:
                                        item.item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
            </p>
            <p *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts"
              class="font-poppins text-start mb-0"
              style="line-height: 1;color: #858585; font-weight: 500;"
              [ngStyle]="{
                'font-size':  item.item?.converted_amounts?.taxPrice | dynamicFontSize: 15 : fontSizeAdjustments
              }"
            >
            <!-- {{currencyItinerary}} {{ taxSum | number : "1.2-2" }} -->
             {{currencyAgency?.code}} {{ item.item?.converted_amounts?.taxPrice | number: '1.2-2'}}
            </p>
            <p *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts"
              class="font-poppins text-start mb-0"
              style="line-height: 1;color: #858585; font-weight: 500;"
              [ngStyle]="{
                'font-size':  taxSum
                            | currencyConverterPure:
                              currencyItinerary:
                              currencyAgency?.code:
                              currencies
                            | dynamicFontSize: 16 : fontSizeAdjustments
              }"
            >
            <!-- {{currencyItinerary}} {{ taxSum | number : "1.2-2" }} -->
             {{currencyAgency?.code}} {{ taxSum
                                      | currencyConverterPure:
                                        currencyItinerary:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
            </p>
             <div *ngIf="item.item.status_id !== 5">
            <span *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider">
                <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="item.item.currency"
                                                [valueProduct]="taxSum"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts">
                  <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="currencyAgency.code"
                                                [valueProduct]="item.item?.converted_amounts?.taxPrice"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts">

              </span>
          </div>
          </div>
           <div *ngIf="item.item.status_id !== 5 && item.item.currency !== currencyAgency?.code">
                                  <div class="d-flex justify-content-end align-items-center">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 15px; font-weight: 500;color: #858585; line-height: 1;"

                                    >{{item.item.currency}} {{taxSum | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                        <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
      </div>

      <div class="d-flex flex-column px-0 mt-3" style="text-align: end">
        <p class="font-poppins font-verde f-15 font-weight-bold text-uppercase text-price mb-2 text-start">Tarifa Total</p>

        <!-- COMENTADO YOVANNY 09-07-2024
         <p *ngIf="!showTextChangeDetailsProducts" class="font-poppins number-price font-verde mb-0 text-start">  {{ netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax | number : "1.2-2" }}</p>
       <!- -->

        <!-- {{ optionNightsNetTotalProf > 0 ? optionNightsNetTotalProf : optionNightsNetTotalFreeTax | number : "1.2-2" }} -->
          <div class="d-flex justify-content-end">
            <p
              *ngIf="showTextChangeDetailsProducts"
              class="font-poppins font-verde text-start  mb-0"
              style="line-height: 1; font-weight: 500;"
              [ngStyle]="{
                'font-size': (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax )
                            | currencyConverterPure:
                              currencyItinerary:
                              currencyAgency?.code:
                              currencies
                            | dynamicFontSize: 15 : fontSizeAdjustments
              }"
            >
            <!-- {{currencyItinerary}} {{ (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax ) | number : "1.2-2" }} -->
             <span *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider">
                              <span *ngIf="item.item.status_id !== 5">

              {{currencyAgency?.code}} {{ (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax )
                                      | currencyConverterPure:
                                        item.item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
                              </span>
                                  <span *ngIf="item.item.status_id === 5">
                {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
              </span>

             </span>
             <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts">
                                        <span *ngIf="item.item.status_id !== 5">
                {{currencyAgency.code}} {{ (item.item?.converted_amounts?.netPriceBooking > 0 ? item.item?.converted_amounts?.netPriceBooking : item.item?.converted_amounts?.netPriceBookingFreeTax ) | number: '1.2-2'}}
              </span>

              <span *ngIf="item.item.status_id === 5">
                 {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
              </span>
             </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts">
                <span *ngIf="item.item.status_id !== 5">
                        {{item.item.currency}} {{ (taxSum > 0 ? netPriceBookingFreeTax : netPriceBooking ) | number : '1.2-2' }}
                </span>
              <span *ngIf="item.item.status_id === 5">
                {{currencyAgency.code}} {{ 0 | number: '1.2-2'}}
              </span>
            </span>
          </p>
          <div *ngIf="item.item.status_id !== 5">
            <span *ngIf="!item.item.isPendigApprovePay && !item.item.isPaidAgency && !item.item.isPaidProvider">
                <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="item.item.currency"
                                                [valueProduct]=" (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax )"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && item.item?.converted_amounts">
                  <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientsSettingAppBooking"
                                                [currencyProduct]="currencyAgency.code"
                                                [valueProduct]="(item.item?.converted_amounts?.netPriceBooking > 0 ? item.item?.converted_amounts?.netPriceBooking : item.item?.converted_amounts?.netPriceBookingFreeTax )"
                                                >
                </usb-tooltip-convert-amount>
              </span>
              <span *ngIf="(item.item.isPendigApprovePay || item.item.isPaidAgency || item.item.isPaidProvider) && !item.item?.converted_amounts">

              </span>
          </div>
          </div>
            <div *ngIf="item.item.status_id !== 5 || item.item.currency !== currencyAgency?.code">
                                  <div class="d-flex justify-content-end align-items-center">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 15px; font-weight: 400;color: #858585; font-weight: 500;line-height: 1;"

                                    >{{item.item.currency}} {{(netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax ) | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                   <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
      </div>
      <div class="d-flex flex-column mt-2 adjust-bks">
        <div class="d-flex align-items-center justify-content-end">
          <!-- <img src="/assets/img/app/little-icons/badge-bks.png" class="img-fluid icon-premium-point" /> -->
          <p *ngIf="!showTextChangeDetailsProducts" class="text-left m-0" style="font-family: 'Poppins';font-size: 15px;font-weight: 500; color: #f5bf29 !important; line-height: 1;">
            BKS {{ blickoins | number : "1.2-2" }}
          </p>
          <p
            *ngIf="showTextChangeDetailsProducts"
            class="text-left m-0"
            style="font-family: 'Poppins';font-size: 15px;font-weight: 500;color: #f5bf29 !important; line-height: 1;"
          >
            BKS {{ blickoins | number : "1.2-2" }}
          </p>
        </div>
        <div>
          <p *ngIf="!showTextChangeDetailsProducts" class="text-right m-0" style="font-family: 'Poppins';font-size: 15px;font-weight: 500;color: #f5bf29 !important; line-height: 1;">
            USD {{ creditBlickoins | number : "1.2-2" }}
          </p>
          <p
            *ngIf="showTextChangeDetailsProducts"
            class=" text-right m-0"
            style="font-family: 'Poppins';font-weight: 500;font-size: 15px;color: #f5bf29 !important; line-height: 1;"

          >
            USD {{ creditBlickoins | number : "1.2-2" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
